export default __webpack_public_path__ + "locales/tr/Payments.json?hash=d39e64ff048caf04bea59a3dc06131b7";